import { type TFunction } from 'i18next';
import type * as React from 'react';
import { type SearchableFieldCustom } from '../../ISearchableField.tsx';
import { truncateFilterBarString } from './truncateFilterBarString.ts';

/**
 * Formatter per campi `Custom`. Usa `field.renderValue` se definito, altrimenti
 * fallback per type del valore (array → "N selezionati", boolean → Sì/No, …).
 * Pensato per non costringere i Custom esistenti a definire `renderValue` solo
 * per la FilterBar.
 */
export function formatCustomFilterBarValue(
  field: SearchableFieldCustom,
  value: unknown,
  t: TFunction,
): React.ReactNode {
  if (field.renderValue) {
    return field.renderValue(value);
  }

  if (value === null || value === undefined) {
    return null;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return null;
    }
    return t('filter-bar.selected-count', '{{count}} selezionati', {
      count: value.length,
    });
  }

  if (typeof value === 'boolean') {
    return value ? t('filter-bar.yes', 'Sì') : t('filter-bar.no', 'No');
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string') {
    return value === '' ? null : truncateFilterBarString(value);
  }

  console.warn('[formatCustomFilterBarValue] Valore custom non gestito', {
    field,
    value,
  });
  return t('filter-bar.read-only-value', '—');
}
